import { reaction } from 'mobx';
import ExecuteBaseManager from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/execute-manager/execute-base-manager';
import { IObserverParams } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-interface';

export default class ConvertTimingSdkManager extends ExecuteBaseManager {
    public static instance;
    public static getInstance(): ConvertTimingSdkManager {
        if (!this.instance) {
            this.instance = new ConvertTimingSdkManager();
        }
        return this.instance;
    }

    /**
     * 监听子元素转换完成
     */
    protected addExecuteObserver = ({ slideModel, callback }: IObserverParams): void => {
        const convertedReaction = reaction(
            () => slideModel.childrenConverted,
            (converted) => {
                if (converted) {
                    callback?.();
                    // 释放reaction监听
                    convertedReaction?.();
                }
            },
        );
    };

    // 检查slide的动画sdk数据已经转换完成
    protected checkIsExecuted = (slideIndex: number): boolean => {
        const slideModel = this.presentation.children[slideIndex];
        return !!slideModel?.timingModel;
    };

    // 转换页面的动画数据
    protected taskFunc = ({ slideModel }: IObserverParams): void => {
        if (slideModel.childrenConverted) {
            slideModel.convertTimingDataSdkToUi();
        } else {
            // 子元素没有转换完成，则监听子元素的转换状态
            this.addExecuteObserver({
                slideModel,
                callback: () => {
                    slideModel.convertTimingDataSdkToUi();
                },
            });
        }
    };

    // 创建taskKey
    protected createTaskKey = (slideKey: string): string => `convert-timing-${slideKey}`;
}
